import { Route, Routes } from 'react-router-dom'

import { TwoColumnLayout } from '../layouts/TwoColumnLayout'
import { GridDetails } from './GridDetails'
import { GridReduxHandler } from './GridReduxHandler'
import { GridsList } from './GridsList'
import { Map } from './Map'

import type { FC } from 'react'

export const GridsLeftNavRoutes: FC = () => {
	return (
		<GridReduxHandler>
			<Routes>
				<Route index element={<GridsList />} />
				<Route path="add" element={<GridDetails />} />
				<Route path=":gridId" element={<GridDetails />} />
			</Routes>
		</GridReduxHandler>
	)
}

export const GridsMainContentRoutes: FC = () => {
	return (
		<Routes>
			<Route index element={<Map />} />
			<Route path="add" element={<Map />} />
			<Route path=":gridId" element={<Map />} />
		</Routes>
	)
}

export const GridsRoutes: FC = () => {
	return (
		<GridReduxHandler>
			<TwoColumnLayout left={<GridsLeftNavRoutes />} right={<GridsMainContentRoutes />} />
		</GridReduxHandler>
	)
}
